/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_Blocked_Chrome_1Inputs */



/**
* | output |
* | --- |
* | "Click the icon with the sliders to the left of the web address." |
*
* @param {Practice_Session_Mic_Blocked_Chrome_1Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_chrome_1 = /** @type {((inputs?: Practice_Session_Mic_Blocked_Chrome_1Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_Chrome_1Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Klik op het icoon met de schuifjes links van het webadres.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez sur l'icône avec les curseurs à gauche de l'adresse web.")
	return /** @type {LocalizedString} */ ("Click the icon with the sliders to the left of the web address.")
});